import dayjs from "dayjs";
import moment from "moment";
import { Modal, Button, DatePicker } from "antd";
import {
  PlusOutlined,
  MinusOutlined,
  UserOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useState, useEffect, useMemo } from "react";
import { formatCurrency } from "../../../../../utils/formatCurrency";

export const FilterRooms = (props) => {
  const {
    isMobile,
    searchBarGradient,
    dateRange,
    handleDateRangeChange,
    adultsFilter,
    setAdultsFilter,
    childrenFilter,
    setChildrenFilter,
    promoCode,
    setPromoCode,
    handleApplyPromoAndFilter,
    t,
    childrenPolicy,
  } = props;
  const childrenFreeAge = useMemo(
    () => childrenPolicy?.childrenAgeRule?.freeAge || 0,
    [childrenPolicy]
  );
  const childrenMaxAge = useMemo(
    () => childrenPolicy?.childrenAgeRule?.maxAge || 0,
    [childrenPolicy]
  );
  const childrenExtraPrice = useMemo(
    () => childrenPolicy?.childrenAgeRule?.extraPrice || 0,
    [childrenPolicy]
  );

  const [isGuestModalVisible, setIsGuestModalVisible] = useState(false);
  const [localAdults, setLocalAdults] = useState(adultsFilter || 1);
  const [localChildren, setLocalChildren] = useState(childrenFilter || 0);
  const [childAges, setChildAges] = useState([]);

  useEffect(() => {
    setLocalAdults(adultsFilter || 1);
  }, [adultsFilter]);

  useEffect(() => {
    setLocalChildren(childrenFilter || 0);
  }, [childrenFilter]);

  useEffect(() => {
    // ensure childAges length matches localChildren
    const ages = [...childAges];
    while (ages.length < localChildren)
      ages.push(childrenMaxAge > 0 ? Math.max(1, childrenMaxAge - 1) : 1);
    while (ages.length > localChildren) ages.pop();
    setChildAges(ages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localChildren]);

  const showGuestModal = () => setIsGuestModalVisible(true);
  const [isInfoModalVisible, setIsInfoModalVisible] = useState(false);
  const showInfoModal = () => setIsInfoModalVisible(true);
  const handleInfoCancel = () => setIsInfoModalVisible(false);
  const handleGuestOk = () => {
    setAdultsFilter(localAdults);
    setChildrenFilter(localChildren);
    setIsGuestModalVisible(false);
  };
  const handleGuestCancel = () => setIsGuestModalVisible(false);

  const increment = (setter, value) => setter((v) => v + 1);
  const decrement = (setter, value) => setter((v) => Math.max(0, v - 1));

  const handleChildAgeChange = (index, value) => {
    const copy = [...childAges];
    copy[index] = Number(value);
    setChildAges(copy);
  };
  return (
    <div
      className="searchbar row mt-5 bs d-flex align-items-center filter-room-wrapper"
      style={{
        background: searchBarGradient,
      }}
    >
      <div className="col-md-6 col-12">
        <div className="filter-date-range-field">
          <div className="filter-date-range-labels">
            <span>{t("filter_room.Check_in")}</span>
            <span>{t("filter_room.Check_out")}</span>
          </div>
          <div className="filter-date-range">
            {/* antd works with dayjs; dateRange state and handleDateRangeChange stay moment-based */}
            <DatePicker.RangePicker
              placeholder={[t("filter_room.Check_in"), t("filter_room.Check_out")]}
              value={[
                dateRange?.[0] ? dayjs(dateRange[0].toDate()) : null,
                dateRange?.[1] ? dayjs(dateRange[1].toDate()) : null,
              ]}
              onChange={(range) =>
                handleDateRangeChange([
                  range?.[0] ? moment(range[0].toDate()).startOf("day") : null,
                  range?.[1] ? moment(range[1].toDate()).startOf("day") : null,
                ])
              }
              format="DD-MM-YYYY"
              disabledDate={(current) => current && current < dayjs().startOf("day")}
              allowClear={false}
              inputReadOnly={isMobile}
              popupClassName="filter-room-range-popup"
              variant="borderless"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
      <div className="adult col-md-6 d-flex align-items-center mb-2">
        <div
          onClick={showGuestModal}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") showGuestModal();
          }}
          className="filter-guest-option"
        >
          {isMobile ? (
            <div style={{ fontWeight: 500, fontSize: 12 }}>
              {localAdults} {t("filter_room.adults")}, {localChildren}{" "}
              {t("filter_room.children")}
            </div>
          ) : (
            <div style={{ flex: 1, textAlign: "left" }}>
              <div style={{ fontSize: 12, color: "#666" }}>
                {t("filter_room.guests")}
              </div>
              <div style={{ fontWeight: 500, fontSize: 16 }}>
                {localAdults} {t("filter_room.adults")}, {localChildren}{" "}
                {t("filter_room.children")}
              </div>
            </div>
          )}
          {!isMobile && (
            <UserOutlined
              style={{ fontSize: 22, color: "#f0ad4e", marginLeft: 10 }}
            />
          )}
        </div>
        <input
          type="text"
          className="form-control"
          placeholder={t("homescreen.promo_code")}
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          style={{ marginRight: "10px", borderColor: "white" }}
        />
        <button
          type="button"
          className="form-control btn btn-primary mt-2 apply-button"
          onClick={handleApplyPromoAndFilter}
          style={{ width: "auto" }}
        >
          {t("homescreen.apply")}
        </button>
      </div>

      {/* Guest Modal */}
      <Modal
        title={t("filter_room.guests")}
        visible={isGuestModalVisible}
        onOk={handleGuestOk}
        onCancel={handleGuestCancel}
        okText={t("filter_room.save")}
        cancelText={t("filter_room.cancel")}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div>
            <div>{t("filter_room.adults")}</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ddd",
                padding: 8,
                borderRadius: 6,
              }}
            >
              <Button
                onClick={() => decrement(setLocalAdults)}
                icon={<MinusOutlined />}
              />
              <div style={{ padding: "0 12px" }}>{localAdults}</div>
              <Button
                onClick={() => increment(setLocalAdults)}
                icon={<PlusOutlined />}
              />
            </div>
          </div>
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {t("filter_room.children_under_age", { age: childrenMaxAge })}{" "}
              <InfoCircleOutlined
                onClick={showInfoModal}
                onKeyPress={(e) => {
                  if (e.key === "Enter") showInfoModal();
                }}
                tabIndex={0}
                role="button"
                title="Children Policy"
                style={{
                  fontSize: 18,
                  color: "#666",
                  cursor: "pointer",
                  marginLeft: 8,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ddd",
                padding: 8,
                borderRadius: 6,
              }}
            >
              <Button
                onClick={() => decrement(setLocalChildren)}
                icon={<MinusOutlined />}
              />
              <div style={{ padding: "0 12px" }}>{localChildren}</div>
              <Button
                onClick={() => increment(setLocalChildren)}
                icon={<PlusOutlined />}
              />
            </div>
          </div>
        </div>

        {Array.from({ length: localChildren }).map((_, idx) => (
          <div
            key={`child-age-${idx}`}
            style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
          >
            <div style={{ flex: 1 }}>
              {t("filter_room.child_age", { number_of_children: idx + 1 })}
            </div>
            <select
              value={childAges[idx] || ""}
              onChange={(e) => handleChildAgeChange(idx, e.target.value)}
              className="form-control"
              style={{ width: 160 }}
            >
              {Array.from({ length: childrenMaxAge - 1 }).map((_, ageIdx) => (
                <option key={ageIdx} value={ageIdx + 1}>
                  {ageIdx + 1} {t("filter_room.years_old")}
                </option>
              ))}
            </select>
          </div>
        ))}
      </Modal>

      {/* Children Policy Modal */}
      <Modal
        title={null}
        visible={isInfoModalVisible}
        footer={null}
        onCancel={handleInfoCancel}
        centered
      >
        <div>
          <div
            style={{
              marginRight: 8,
              color: "#666",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            {t("filter_room.children_policy")}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: t("filter_room.children_policy_text", {
                childrenFreeAge,
                childrenMaxAge,
                childrenExtraPrice: formatCurrency(childrenExtraPrice),
                childrenFreeAgePlusOne: childrenFreeAge + 1,
                childrenMaxAgePlusOne: childrenMaxAge + 1,
              }),
            }}
          />
        </div>
      </Modal>
    </div>
  );
};
